"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.None = exports.Some = exports.Maybe = void 0;

var Maybe = /*#__PURE__*/function () {
  function Maybe() {
    _classCallCheck(this, Maybe);
  }

  _createClass(Maybe, null, [{
    key: "of",
    value: function of(value) {
      return value === undefined || value === null ? None.of() : Some.of(value);
    }
  }]);

  return Maybe;
}();

exports.Maybe = Maybe;

var Some = /*#__PURE__*/function () {
  function Some(value) {
    _classCallCheck(this, Some);

    this.value = value;
    this.isSome = true;
    this.isNone = false;
  }

  _createClass(Some, [{
    key: "map",
    value: function map(f) {
      return Maybe.of(f(this.value));
    }
  }, {
    key: "flatMap",
    value: function flatMap(f) {
      return f(this.value);
    }
  }, {
    key: "get",
    value: function get() {
      return this.value;
    }
  }, {
    key: "getOrElse",
    value: function getOrElse(_value) {
      return this.value;
    }
  }, {
    key: "defaulting",
    value: function defaulting(value) {
      return Maybe.of(this.getOrElse(value));
    }
  }], [{
    key: "of",
    value: function of(value) {
      if (value === null || value === undefined) {
        throw new Error('value is ${value}');
      }

      return new Some(value);
    }
  }]);

  return Some;
}();

exports.Some = Some;

var None = /*#__PURE__*/function () {
  function None() {
    _classCallCheck(this, None);

    this.isSome = false;
    this.isNone = true;
  }

  _createClass(None, [{
    key: "get",
    value: function get() {
      throw new Error('value is null');
    }
  }, {
    key: "getOrElse",
    value: function getOrElse(value) {
      return value;
    }
  }, {
    key: "map",
    value: function map(_f) {
      return new None();
    }
  }, {
    key: "flatMap",
    value: function flatMap(_f) {
      return new None();
    }
  }, {
    key: "defaulting",
    value: function defaulting(value) {
      return Maybe.of(this.getOrElse(value));
    }
  }], [{
    key: "of",
    value: function of() {
      return new None();
    }
  }]);

  return None;
}();

exports.None = None;